import { useMemo } from 'react';
import metricsStore from '@src/globalStore/metricsStore';
import { useAtomValue } from 'jotai';
import { contextTypeAtom } from '@src/atoms/page';

function useTemplateMetrics({ selectedMetricList }) {
  const { combinedMetricsMeta } = metricsStore.getState();
  const contextType = useAtomValue(contextTypeAtom);
  const currentMetricsMeta = combinedMetricsMeta[contextType.toLowerCase()];
  const templateMetricCategoryMap = useMemo(() => {
    const map = {};
    Object.values(currentMetricsMeta).forEach((metric: any) => {
      if (metric.category && metric.template) {
        const res = {
          key: metric.name,
          name: metric.displayName,
          checked: selectedMetricList?.includes(metric.name),
          disabled:
            metric.definitionStatus === 'in_progress' || metric.definitionStatus === 'undefined',
          isHeavyMetric: false,
          template: metric.template,
          definitionStatus: metric.definitionStatus,
        };
        if (map[metric.category]) {
          map[metric.category].push(res);
        } else {
          map[metric.category] = [res];
        }
      }
    });

    // Sorting the options alphabetically for each category
    for (const category in map) {
      map[category].sort((a, b) => a.name.localeCompare(b.name));
    }

    return map;
  }, [selectedMetricList, currentMetricsMeta]);

  const templateMetricCategory = Object.keys(templateMetricCategoryMap);
  const templateMetricCategoryOrder = templateMetricCategory;
  return {
    templateMetricCategories: templateMetricCategoryMap,
    templateMetricCategory,
    templateMetricCategoryOrder,
  };
}

export default useTemplateMetrics;
